/**
 * webPunk identity handoff.
 *
 * A shopper counts as signed in here when the cart carries a `wp_ref` — an
 * opaque token the backend minted for their webPunk account. It rides along
 * into the order's note_attributes, where the orders/create webhook resolves it
 * back to a user.
 *
 * The ref arrives one of two ways:
 *
 *   1. A `.webpunk.com` cookie. The shop and the social platform are subdomains
 *      of the same registrable domain, so a cookie web2 sets is readable here.
 *      Signing in over there therefore signs you in here, with no redirect.
 *   2. A `?wp_ref=` query param, for the sign-in popup handing control back.
 *
 * The ref is deliberately opaque — never a Privy DID or email. Cart attributes
 * are client-writable and visible in the admin, so anything meaningful in here
 * could be forged to credit an order to somebody else's account.
 */
(function () {
  var PARAM = 'wp_ref';
  var COOKIE = 'wp_ref';
  // Matches the server's base64url token. Anything else is not ours — ignore it
  // rather than writing junk onto the cart.
  var TOKEN = /^[A-Za-z0-9_-]{16,64}$/;

  function readCookie(name) {
    var parts = document.cookie ? document.cookie.split(';') : [];
    for (var i = 0; i < parts.length; i++) {
      var pair = parts[i].split('=');
      if (pair.shift().trim() === name) {
        try {
          return decodeURIComponent(pair.join('='));
        } catch (err) {
          return null;
        }
      }
    }
    return null;
  }

  function attach(ref) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { wp_ref: ref } })
    });
  }

  function scrubUrl(params) {
    params['delete'](PARAM);
    var query = params.toString();
    history.replaceState(
      {},
      '',
      window.location.pathname + (query ? '?' + query : '') + window.location.hash
    );
  }

  var params = new URLSearchParams(window.location.search);
  var fromUrl = params.get(PARAM);
  var fromCookie = readCookie(COOKIE);
  // The URL wins: it's the fresher of the two, and it's what the popup hands back.
  var ref = fromUrl && TOKEN.test(fromUrl) ? fromUrl : null;
  if (!ref && fromCookie && TOKEN.test(fromCookie)) ref = fromCookie;

  // Expose the state so the checkout gate can react without re-reading cookies.
  window.webpunkIdentity = {
    ref: ref,
    signedIn: !!ref,
    /** Called by the sign-in popup's opener callback once a ref exists. */
    adopt: function (next) {
      if (!next || !TOKEN.test(next)) return Promise.resolve(false);
      window.webpunkIdentity.ref = next;
      window.webpunkIdentity.signedIn = true;
      return attach(next).then(
        function () {
          return true;
        },
        function () {
          return false;
        }
      );
    }
  };

  if (!ref) return;

  attach(ref)['catch'](function () {
    // Non-fatal: the sale still completes, the order just arrives unlinked and
    // the webhook falls back to matching on the checkout email.
  });

  // Drop the token from the visible URL so it can't leak through the referer
  // header, analytics, or a shared link.
  if (fromUrl) scrubUrl(params);
})();
